import React from 'react';
import '../styles/TermsConditions.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsConditions = () => {
  const lastUpdated = 'MAY 30, 2026';

  return (
    <section id="terms-conditions" className="terms-section">
        <Navbar/>
      <div className="terms-container">
        
        {/* Hero Section */}
        <div className="terms-hero">
          <div className="terms-hero-content">
            <h1 className="terms-title">Terms & Conditions</h1>
            <p className="terms-subtitle">
              Please read these terms carefully before using our website or services.
            </p>
            <div className="terms-last-updated">
              <span>📅 Last Updated: {lastUpdated}</span>
            </div>
          </div>
        </div>

        {/* Quick Navigation */}
        <div className="terms-nav">
          <h3>Quick Navigation</h3>
          <div className="terms-nav-links">
            <a href="#acceptance">Acceptance of Terms</a>
            <a href="#services">Services</a>
            <a href="#orders">Orders & Payments</a>
            <a href="#shipping">Shipping & Delivery</a>
            <a href="#returns">Returns & Refunds</a>
            <a href="#warranty">Warranty</a>
            <a href="#byob">BYOB Program</a>
            <a href="#liability">Limitation of Liability</a>
            <a href="#contact-terms">Contact Us</a>
          </div>
        </div>

        <div className="terms-content">
          
          {/* 1. Acceptance of Terms */}
          <div id="acceptance" className="terms-section-block">
            <h2>1. Acceptance of Terms</h2>
            <div className="terms-underline"></div>
            <p>
              By accessing or using the Preferred Audiology Pvt. Ltd. website ("our website," "we," "us," "our"), 
              you agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, 
              please do not use our website or services.
            </p>
            <p>
              We reserve the right to modify these terms at any time. Your continued use of the website 
              following any changes constitutes your acceptance of the modified terms.
            </p>
          </div>

          {/* 2. Our Services */}
          <div id="services" className="terms-section-block">
            <h2>2. Our Services</h2>
            <div className="terms-underline"></div>
            <p>Preferred Audiology Pvt. Ltd. provides the following services:</p>
            <ul>
              <li><strong>Hearing Aid Manufacturing & Distribution</strong> - Premium quality hearing aids for clinics and distributors</li>
              <li><strong>BYOB (Build Your Own Brand) Program</strong> - Private label hearing aid branding services</li>
              <li><strong>Custom Branding</strong> - Logo placement, custom packaging, and branding solutions</li>
              <li><strong>Clinic Support Program</strong> - Training, marketing support, and technical assistance</li>
              <li><strong>B2B Wholesale</strong> - Bulk orders for clinics, distributors, and retail chains</li>
            </ul>
          </div>

          {/* 3. Eligibility */}
          <div className="terms-section-block">
            <h2>3. Eligibility</h2>
            <div className="terms-underline"></div>
            <p>To use our services, you must:</p>
            <ul>
              <li>Be at least 18 years of age</li>
              <li>Have the legal capacity to enter into binding contracts</li>
              <li>Provide accurate and complete information during registration or inquiry</li>
              <li>Be a legitimate business entity (for B2B services) including clinics, distributors, or retail chains</li>
            </ul>
          </div>

          {/* 4. Orders & Payments */}
          <div id="orders" className="terms-section-block">
            <h2>4. Orders & Payments</h2>
            <div className="terms-underline"></div>
            <p><strong>Order Confirmation:</strong> All orders are subject to acceptance and availability. We reserve the right to refuse any order.</p>
            <p><strong>Pricing:</strong> All prices are B2B prices and are subject to change without notice. Final pricing will be confirmed in the invoice.</p>
            <p><strong>Payment Terms:</strong></p>
            <ul>
              <li>100% advance payment for first-time orders</li>
              <li>50% advance + 50% before dispatch for repeat orders</li>
              <li>Letter of Credit available for large orders</li>
              <li>GST invoices provided for all transactions</li>
            </ul>
            
          </div>

          {/* 5. Shipping & Delivery */}
          <div id="shipping" className="terms-section-block">
            <h2>5. Shipping & Delivery</h2>
            <div className="terms-underline"></div>
            <p><strong>Delivery Timeline:</strong></p>
            <ul>
              <li>Standard orders: Less than 30 days from order confirmation</li>
              <li>Custom branding orders: Less than 30 days</li>
              <li>Express delivery: Available at additional cost</li>
            </ul>
            <p><strong>Shipping Charges:</strong> Shipping charges are calculated based on order value, weight, and delivery location. Charges will be communicated before order confirmation.</p>
            <p><strong>Risk of Loss:</strong> Once the products are shipped, the risk of loss passes to the buyer. We are not responsible for delays caused by logistics partners or unforeseen circumstances.</p>
          </div>

          {/* 6. Returns & Refunds */}
          <div id="returns" className="terms-section-block">
            <h2>6. Returns & Refunds</h2>
            <div className="terms-underline"></div>
            <p><strong>Return Policy:</strong></p>
            <ul>
              <li>Damaged or defective products can be returned within 7 days of delivery</li>
              <li>Custom branded products are not eligible for return unless defective</li>
              <li>Products must be in original packaging with all accessories</li>
            </ul>
            <p><strong>Refund Process:</strong></p>
            <ul>
              <li>Refunds will be processed within 7-10 business days after quality check</li>
              <li>Refunds will be issued via the original payment method</li>
              <li>Shipping charges are non-refundable</li>
            </ul>
            <p><strong>Replacement:</strong> Manufacturing defects will be replaced free of cost within the warranty period.</p>
          </div>

          {/* 7. Warranty */}
          <div id="warranty" className="terms-section-block">
            <h2>7. Warranty</h2>
            <div className="terms-underline"></div>
            <p><strong>Product Warranty:</strong></p>
            <ul>
              <li>QUICKFIT ANC R. : 1 year manufacturing warranty</li>
              <li>Warranty covers manufacturing defects only</li>
              <li>Warranty does not cover damage due to misuse, accidents, or unauthorized repairs</li>
            </ul>
            <p><strong>Instant Service & Replacement:</strong> Under this program, eligible products can be replaced instantly at the clinic. Terms apply.</p>
          </div>

          {/* 8. BYOB Program */}
          <div id="byob" className="terms-section-block">
            <h2>8. BYOB (Build Your Own Brand) Program</h2>
            <div className="terms-underline"></div>
            <p><strong>Program Terms:</strong></p>
            <ul>
              <li>Minimum order quantity: 100 units</li>
              <li>Lead time: Less than 30 days from design approval</li>
              <li>Custom artwork and packaging require final approval</li>
              <li>Brand ownership remains with the partner</li>
              <li>We reserve the right to use the products in our portfolio (without partner branding)</li>
            </ul>
            <p><strong>Customization Options:</strong> Logo placement, packaging design, color options, box printing, user manual branding, and demo video customization are available with applicable charges.</p>
          </div>

          {/* 9. Intellectual Property */}
          <div className="terms-section-block">
            <h2>9. Intellectual Property</h2>
            <div className="terms-underline"></div>
            <p>
              All content on this website, including text, images, logos, graphics, and software, is the property 
              of Preferred Audiology Pvt. Ltd. and is protected by copyright laws.
            </p>
            <p>You may not:</p>
            <ul>
              <li>Copy, reproduce, or distribute any content without written permission</li>
              <li>Use our trademarks or logos without authorization</li>
              <li>Modify or create derivative works from our content</li>
            </ul>
          </div>

          {/* 10. User Conduct */}
          <div className="terms-section-block">
            <h2>10. User Conduct</h2>
            <div className="terms-underline"></div>
            <p>You agree not to:</p>
            <ul>
              <li>Use our website for any illegal purpose</li>
              <li>Interfere with the security or functionality of our website</li>
              <li>Upload malicious code or viruses</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Misrepresent your identity or affiliation</li>
            </ul>
          </div>

          {/* 11. Limitation of Liability */}
          <div id="liability" className="terms-section-block">
            <h2>11. Limitation of Liability</h2>
            <div className="terms-underline"></div>
            <p>
              To the maximum extent permitted by law, Preferred Audiology Pvt. Ltd. shall not be liable for any 
              indirect, incidental, special, consequential, or punitive damages arising from your use of our 
              website or services.
            </p>
            <p>
              Our total liability for any claim arising from these terms shall not exceed the amount paid 
              by you for the products or services in question.
            </p>
          </div>

          {/* 12. Indemnification */}
          <div className="terms-section-block">
            <h2>12. Indemnification</h2>
            <div className="terms-underline"></div>
            <p>
              You agree to indemnify and hold Preferred Audiology Pvt. Ltd., its officers, directors, employees, 
              and agents harmless from any claims, damages, losses, or expenses arising from your violation of 
              these terms or your use of our services.
            </p>
          </div>

          {/* 13. Termination */}
          <div className="terms-section-block">
            <h2>13. Termination</h2>
            <div className="terms-underline"></div>
            <p>
              We reserve the right to terminate or suspend your access to our services at any time, without notice, 
              for conduct that violates these terms or is harmful to other users or our business interests.
            </p>
          </div>

          {/* 14. Governing Law */}
          <div className="terms-section-block">
            <h2>14. Governing Law</h2>
            <div className="terms-underline"></div>
            <p>
              These terms shall be governed by and construed in accordance with the laws of India. 
              Any disputes arising under these terms shall be subject to the exclusive jurisdiction of 
              the courts in Kolkata, West Bengal.
            </p>
          </div>

          {/* 15. Severability */}
          <div className="terms-section-block">
            <h2>15. Severability</h2>
            <div className="terms-underline"></div>
            <p>
              If any provision of these terms is found to be unenforceable or invalid, that provision shall be 
              limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain 
              in full force and effect.
            </p>
          </div>

          {/* 16. Entire Agreement */}
          <div className="terms-section-block">
            <h2>16. Entire Agreement</h2>
            <div className="terms-underline"></div>
            <p>
              These terms constitute the entire agreement between you and Preferred Audiology Pvt. Ltd. 
              regarding your use of our website and services, superseding any prior agreements.
            </p>
          </div>

          {/* 17. Contact Information */}
          <div id="contact-terms" className="terms-section-block">
            <h2>17. Contact Us</h2>
            <div className="terms-underline"></div>
            <p>If you have any questions about these Terms & Conditions, please contact us:</p>
            <div className="terms-contact-info">
              <div className="terms-contact-item">
                <span className="terms-contact-icon">📞</span>
                <div>
                  <strong>Phone</strong>
                  <a href="tel:03323240508">033-23240508</a>
                </div>
              </div>
              <div className="terms-contact-item">
                <span className="terms-contact-icon">✉️</span>
                <div>
                  <strong>Email</strong>
                  <a href="mailto:info@paplhear.com">info@paplhear.com</a>
                </div>
              </div>
              <div className="terms-contact-item">
                <span className="terms-contact-icon">📍</span>
                <div>
                  <strong>Address</strong>
                  <p>Preferred Audiology Pvt. Ltd.<br />
                  Ecospace Business Towers, Tower 5A, Office no. 508<br />
                  New Town, Kolkata - 700160</p>
                </div>
              </div>
            </div>
          </div>

          {/* Download Button */}
          <div className="terms-download">
            <button className="terms-download-btn">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 16L4 18C4 19.1046 4.89543 20 6 20L18 20C19.1046 20 20 19.1046 20 18L20 16M12 4L12 15M12 15L15 12M12 15L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Download Terms & Conditions (PDF)
            </button>
          </div>

        </div>
      </div>
      <Footer/>
    </section>
  );
};

export default TermsConditions;